import { IntegrityMonitorRealTimePanelGzDataProvider } from '../dataProvider/IntegrityMonitorRealTimePanelGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../../webcomponents.constants';

export class IntegrityMonitorRealTimePanelDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IntegrityMonitorRealTimePanelGzDataProvider);
  }
}
